// extracted by mini-css-extract-plugin
export default {"dayContainer":"WeekView_dayContainer__0kOjl","weekViewContainer":"WeekView_weekViewContainer__YD674","dayTitle":"WeekView_dayTitle__vvD-i","daySection":"WeekView_daySection__iFD+h"};